import InvisibleBar from './InvisibleBar'
import TextInput from './TextInput'
import Search from './Search'
import MultiChoice from './MultiChoice'
import Select from './Select'
import TextArea from './TextArea'
import FileUpload from "./FileUpload"

const Input = {
    InvisibleBar,
    MultiChoice,
    Search,
    Select,
    FileUpload,
    TextArea,
    TextInput
}

export default Input